/**
 * Default vuex state
 *
 * @returns {object} Vuex state.
 */
export default () => ({
    archivePlayers: null,
    archiveRecentPlayers: {},
    billingPlans: null,
    planFeatures: null,
    billingSummary: null,
    currentSubscription: null,
    directories: null,
    integrations: null,
    invoices: null,
    listens: {},
    loginRedirectUrl: '/',
    paymentMethods: null,
    platforms: {},
    presumedInvoice: null,
    products: null,
    profileControls: null,
    showCategories: null,
    shows: null,
    sources: {},
    topListens: {},
    topShows: {},
    trackPlayers: null,
    trackPlayersConfig: {},
    trackRecentPlayers: {},
    upcomingInvoice: null,
    user: null,
    userCard: {},
    userSubscription: null,
    UIState: {
        isOnboardingModalVisible: false,
        isUpdateModalVisible: false,
        isBillingPlanChangeVisible: false,
        isResumeSubscriptionModalVisible: false,
        isCancelModalVisible: false,
        isFinishDowngradeView: false,
        isFinishCancelationView: false,
        isSuspended: false,
        preventUnload: false,
        addShowModal: {
            visible: false,
            hash: false,
        },
        upgradeShowModal: {
            visible: false,
            show: false,
            type: null,
            plan: null,
            step: null,
        },
        addEpisodeModal: {
            visible: false,
            context: null,
            file: null,
            episode: {},
            errors: {},
            uploadStatus: null,
            uploadPercentage: 0,
            deferredStore: false,
        },
        deleteShowModal: {
            visible: false,
            showInfo: {},
        },
        showHostingDowngradeModal: {
            visible: false,
            step: 0,
            show: false,
        },
    },
    homeWidgets: [
        {
            component: 'RecentEpisodePlayersWidget',
            column: 1,
            order: 2,
            visible: true,
            subscriptionType: 'all',
        },
        {
            component: 'RecentArchivePlayersWidget',
            column: 1,
            order: 3,
            visible: true,
            subscriptionType: 'all',
        },
        {
            component: 'IntegrationsWidget',
            column: 1,
            order: 4,
            visible: true,
            subscriptionType: 'all',
        },
        {
            component: 'ShowsWidget',
            column: 2,
            order: 3,
            visible: true,
            subscriptionType: 'all',
        },
        {
            component: 'KnowledgeBaseWidget',
            column: 2,
            order: 4,
            visible: true,
            subscriptionType: 'all',
        },
        {
            component: 'AdditionalWebinar',
            column: 2,
            order: 6,
            visible: true,
            subscriptionType: 'pro',
        },
        {
            component: 'HelpWidget',
            column: 2,
            order: 7,
            visible: true,
            subscriptionType: 'all',
        },
    ],
});
